import { Button, Typography } from "@mui/material";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { buttonColors, colors } from "../../utility/types/constant";

interface PayoutOrderBtnProps {
    onClick: () => void;
}

const PayoutOrderBtn = (props: PayoutOrderBtnProps) => {
    const { onClick } = props;

    return (
        <Button
            onClick={onClick}
            variant="outlined"
            startIcon={<FormatListNumberedIcon />}
            sx={{
                borderColor: buttonColors.mainPrimary,
                color: colors.mainPrimary,
            }}>
            <Typography
                variant="subtitle2"
                sx={{
                    color: colors.darkGrey,
                }}>
                Payout Order
            </Typography>
        </Button>
    );
};

export default PayoutOrderBtn;
